import { AxiosResponse } from 'axios';
import { NextApiRequestQuery } from 'next/dist/server/api-utils';
import fetcher, {
    MethodEnum,
    fetcherFull,
} from 'utils/helpers/browser/newFetcher';
import { LegalPersonDetailsPayloadInterface } from 'components/interfaces/ClubInterface';
import { LegalPersonCreateApiInterface } from 'submodules/api_middleware';

export interface FormResponse {
    ok?: boolean;
    error?: any;
    errors?: any;
    message?: string;
    data?: any;
}

export const updateLegalPersonDetails = async (
    id: number,
    data: LegalPersonDetailsPayloadInterface
): Promise<FormResponse> => {
    return await fetcher(
        `/api/legal_person/update/${id}`,
        MethodEnum.PUT,
        null,
        { data }
    );
};

export const createLegalPerson = async (
    data: LegalPersonCreateApiInterface
): Promise<FormResponse> => {
    return await fetcher(`/api/legal_person/create`, MethodEnum.PUT, null, {
        data,
    });
};

export const checkICO = async (ico: string): Promise<FormResponse> => {
    return await fetcher(`/api/legal_person/check_ico`, MethodEnum.GET, {
        value: ico,
    });
};

export const checkVAT = async (vat: string): Promise<FormResponse> => {
    return await fetcher(`/api/legal_person/check_vat`, MethodEnum.GET, {
        value: vat,
    });
};

export const checkInternalIdUnique = async (
    id: string
): Promise<FormResponse> => {
    return await fetcherFull(
        `/api/legal_person/check_internal_id_unique`,
        MethodEnum.GET,
        {
            value: id,
        }
    );
};

export const checkInternalId = async (
    internalId: string
): Promise<FormResponse> => {
    return await fetcher(
        `/api/legal_person/check_internal_id`,
        MethodEnum.GET,
        {
            value: internalId,
        }
    );
};

export const getLegalPerson = async (id: number): Promise<AxiosResponse> => {
    return await fetcher(`/api/legal_person/${id}`, MethodEnum.GET);
};

export const getLegalPersonList = async (
    query: any
): Promise<AxiosResponse> => {
    return await fetcher(`/api/legal_person/list`, MethodEnum.GET, query);
};

export const getLegalPersonFullList = async (
    query: NextApiRequestQuery
): Promise<AxiosResponse> => {
    return await fetcherFull(`/api/legal_person/list`, MethodEnum.GET, query);
};
